import { Box } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";

function SeparatorIcon() {
  return (
    <Box flex="0 0 auto" pr={{ base: 0, md: 15 }} pt={7}>
      <IconChevronRight stroke={1} />
    </Box>
  );
}

export { SeparatorIcon };
